{
 "placeholder": {
  "x": 265,
  "y": 1175,
  "w": 245,
  "h": 32
 },
 "helper": {
  "x": 110,
  "y": 1055,
  "w": 726,
  "h": 59,
  "bands": [
   [
    1056,
    1081
   ],
   [
    1093,
    1109
   ],
   [
    1113,
    1113
   ]
  ]
 },
 "legal": {
  "x": 292,
  "y": 1413,
  "w": 368,
  "h": 52,
  "bands": [
   [
    1413,
    1433
   ],
   [
    1445,
    1446
   ],
   [
    1450,
    1461
   ]
  ]
 }
}